export const CollectionState = {
  NotEntry: '未登録',
  NotHolding: '未所蔵',
  Holding: '所蔵',
  CanLend: '貸出可',
  Lending: '貸出中',
  CanNotLend: '貸出不可',
  HasOrder: '発注有',
  HasSelection: '選定有'
} as const
export type CollectionState = typeof CollectionState[keyof typeof CollectionState]
